import SigliveServiceSSE from 'Service/sigliveServiceSSE';

const postAcceptRequest = async (payload) => {
  const { data } = await SigliveServiceSSE({ method: 'POST', url: '/monitoring-operator/help/accept', data: payload });

  return data?.data;
};

export default postAcceptRequest;
